import {useQuery, UseQueryResult} from '@tanstack/react-query';
import ProblemDetailsError from '../ProblemDetailsError.ts';
import {useCreateAnonymousFetch} from '../useCreateAuthenticatedFetch.ts';
import baseUrl from '../baseUrl.ts';
import {handleResponse} from '../handleResponse.ts';

export const useGetEnabledFeatures = (): UseQueryResult<
    string[],
    Error | ProblemDetailsError
> => {
    const anonymousFetch = useCreateAnonymousFetch();

    return useQuery({
        queryKey: ['enabledFeatures'],
        queryFn: async () => {
            const response = await anonymousFetch(
                `${baseUrl}/api/featureflags/enabled`,
                {method: 'GET'}
            );
            return handleResponse(response);
        }
    });
};
